import { addSearchParams } from '../../lib/url';
import { ApiHost, PaymentFormOptions, PaymentFrameEventsV1, PaymentFrameEventsV2 } from '../../types';

import { PaymentFrame } from './payment-frame';

export { PaymentFrame };

export const paymentForm = <
    PaymentFrameEvents extends PaymentFrameEventsV1 | PaymentFrameEventsV2 = PaymentFrameEventsV1,
>(
    apiHost: ApiHost,
    options: PaymentFormOptions,
) => {
    const { queryParams = {} } = options;

    if (options.cardId) {
        // eslint-disable-next-line camelcase
        queryParams.card_id = options.cardId;
    }

    if (options.sbpLinkTarget) {
        // eslint-disable-next-line camelcase
        queryParams.sbp_link_target = options.sbpLinkTarget;
    }

    if (options.canUseApplePay) {
        // eslint-disable-next-line camelcase
        queryParams.can_use_apple_pay = String(options.canUseApplePay);
    }

    const url = addSearchParams(options.url, queryParams);
    const frame = new PaymentFrame<PaymentFrameEvents>(url, {
        apiHost,
        canUseApplePay: options.canUseApplePay,
        onDomMount: options.onDomMount,
        onDomUnmount: options.onDomUnmount,
    });

    // NB: Promise на будущее, чтобы была возможность работать с API
    return Promise.resolve(frame);
};
